import { MenuItem, OuiMenuComponent } from '@aiz-gl/omni-ui';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-user-menu',
  imports: [OuiMenuComponent],
  templateUrl: './user-menu.component.html',
  standalone: true,
  styles: [
    `
      .user-pill {
        appearance: none;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.25rem 0.875rem 0.25rem 0.25rem;
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: 999px;
        color: var(--text);
        font: inherit;
        font-size: 0.85rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 150ms ease, border-color 150ms ease;
      }

      .user-pill:hover {
        background: var(--subtle);
        border-color: var(--border-light);
      }

      .user-pill__avatar {
        width: 1.625rem;
        height: 1.625rem;
        border-radius: 50%;
        background: var(--primary-light);
        color: var(--primary);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        flex-shrink: 0;
      }

      .user-pill__name {
        line-height: 1.2;
        max-width: 12rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `,
  ],
})
export class UserMenuComponent {
  private readonly router = inject(Router);
  auth = inject(AuthService);

  readonly initials = computed(() => {
    const name = this.auth.userName() || '';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  });

  menuItems: MenuItem[] = [
    {
      label: 'Profile',
      symbolName: 'article_person',
      action: () => this.router.navigate(['/profile']),
    },
    {
      label: 'Sign-Out',
      symbolName: 'logout',
      action: () => this.auth.signOut(),
    },
  ];
}
